import { useNavigate } from "react-router-dom"
import Add from "../table/Add"
import { useEffect, useState } from "react";
import ApiService from "../../services/apiService";
import { toast } from "react-toastify";
import { ErrorWithReasonCode } from "mqtt/*";
import { error } from "console";
import { method } from "lodash";
import { text } from "stream/consumers";
const PowerConsumptionAdd = () =>{
       const navigate = useNavigate();
       const[pumpStationData,setPumpStationData] = useState<any[]>()

       useEffect(()=>{
           const fecthPumpStation = async() =>{
              try{
                 const response = await ApiService.axiosApi(`/pumpstation`,{
                     method:'GET',
                     params:{
                          pageNumber:0,
                          pageSize:0
                     }
                 })

                 if(response.success){
                     setPumpStationData(response.data.data);
                 }else{
                     console.log( response.message || response.status || 'Unable to get message')
                 }

              }catch(error){
                 console.log(error)
              }
           }
           fecthPumpStation();
       },[])

       const onSubmit =async(data:any) =>{
           try{
              const response = await ApiService.axiosApi(`/powerconsumption`,{
                 method:'POST',
                 data:data,

              })
              if(response.success){
                 toast.success('Power Consumption Added Successfully')
                 navigate(-1)
              }else{
                 toast.error('Unable to Add Power Consumption ')
              }
           }catch(error){
             console.log(error)
           }
       }

    return(
         <>
           <Add
               title='Add Power Consumption'
               parentTitle = 'Power Consumption'
               onSubmit ={onSubmit}

               fields = {[
                  {
                     name:'PowerConsumption_KWH',
                     label:'Power Consumption (kWh)',
                     type:'text',
                     validation:{required:"Power Consumption Is Required"}
                  },
                  {
                     
                        name:'DateTime',
                        label:'Date & Time',
                        type:'dateTime',
                        validation:{ required:"Date & Time is Required" }
                      
                  }
               ]}
            />
         </>
    )
}

export default PowerConsumptionAdd;